import { IDataHandler } from '../IDataHandler';
import { TrackingEventName } from '../TrackingEvent';
import { EntryPointDataSet } from '../DataSet/EntryPoint';

export const TrackingEventDataMap: {
    [key in TrackingEventName]: (keyof EntryPointDataSet)[];
} = {
    [TrackingEventName.gameStarted]: [
        'epContext',
        'epCustomEntryPoint',
        'entryPoint',
        'epSenderId',
        /*'epSenderLevel',
        'epSenderDaysInGame',
        'epSenderCoins',
        'epSenderIsPayer',
        'epTimestamp',*/
        'epPromoSource',
        'epBotMsgCategory',
        'epBotMsgId',
        // 'epBotGiftId',
        'epChanger',
        'epRemoveOne',
        'epMassRemove',
        'epJoker',
        'epCoins',
        'epLives',
        // 'campaignID',
    ],
    [TrackingEventName.newPlayer]: [
        'epContext',
        'epCustomEntryPoint',
        'entryPoint',
        'epSenderId',
        /*'epSenderLevel',
        'epSenderDaysInGame',
        'epSenderCoins',
        'epSenderIsPayer',
        'epTimestamp',*/
        'epPromoSource',
        'epBotMsgCategory',
        'epBotMsgId',
        // 'epBotGiftId',
        'epChanger',
        'epRemoveOne',
        'epMassRemove',
        'epJoker',
        'epCoins',
        'epLives',
        // 'campaignID',
    ],
};

export class EntryPointDataHandler implements IDataHandler<EntryPointDataSet> {
    public data: EntryPointDataSet = new EntryPointDataSet();

    public getEventData(eventName: TrackingEventName): EntryPointDataSet {
        const data = TrackingEventDataMap[eventName].reduce(
            (acc, key) => {
                acc[key] = this.data[key];
                return acc;
            },
            {} as EntryPointDataSet
        );

        return data;
    }
}
